import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

interface Props {
  children?: React.ReactNode;
  title?: string;
  description?: string;
  disabled?: boolean;
  onCancel?: () => void;
  onConfirm?: () => void;
  confirmText?: string;
  isLoading?: boolean;
  asChild?: boolean;
  open?: boolean;
}

export const ConfirmationDialog = ({
  title,
  disabled,
  description,
  onCancel,
  onConfirm,
  children,
  confirmText,
  isLoading,
  asChild = false,
  open,
}: Props) => {
  if (disabled) {
    return children;
  }

  return (
    <Dialog open={open}>
      {children && <DialogTrigger asChild={asChild}>{children}</DialogTrigger>}
      <DialogContent onClose={onCancel}>
        <DialogHeader>
          <DialogTitle>{title || "Are you sure?"}</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          {description || "Press yes to confirm this action."}
        </DialogDescription>
        <DialogFooter>
          <DialogClose disabled={isLoading} asChild>
            <Button
              type="button"
              variant="ghost"
              disabled={isLoading}
              onClick={onCancel}
              className="min-w-[140px]"
            >
              Cancel
            </Button>
          </DialogClose>
          <DialogClose disabled={isLoading} asChild>
            <Button
              type="button"
              variant="default"
              disabled={isLoading}
              onClick={onConfirm}
              className="min-w-[140px]"
            >
              {confirmText || "Confirm"}
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
